(function () {
  'use strict';

  var SHIPPING_SUMMARY_DEFAULT = 'Shipping is calculated at checkout based on your address.';
  var CART_REQUEST_TIMEOUT = 15000;
  var changeTimer = 0;
  var pendingChange = null;
  var mutationQueue = Promise.resolve();
  var activeMutations = 0;

  window.__paransCartMetrics = window.__paransCartMetrics || [];

  function getForm() {
    return document.getElementById('ParansCartForm');
  }

  function setCartBusy(active) {
    var form = getForm();
    var overlay = form && form.querySelector('[data-parans-cart-loading]');
    if (!form) return;
    form.toggleAttribute('aria-busy', active);
    form.querySelectorAll('.parans-cart__step, .parans-cart__remove, .parans-cart__coupon-btn').forEach(function (control) {
      control.disabled = active;
      control.setAttribute('aria-disabled', active ? 'true' : 'false');
    });
    if (overlay) {
      overlay.hidden = !active;
      overlay.setAttribute('aria-hidden', active ? 'false' : 'true');
    }
  }

  function showCartError(message) {
    var form = getForm();
    var error = form && form.querySelector('[data-parans-cart-error]');
    if (!error) return;
    error.textContent = message || 'The cart could not be updated. Please try again.';
    error.hidden = false;
  }

  function clearCartError() {
    var form = getForm();
    var error = form && form.querySelector('[data-parans-cart-error]');
    if (error) error.hidden = true;
  }

  function requestCart(url, body, kind) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var startedAt = performance.now();
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, CART_REQUEST_TIMEOUT);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
      signal: controller ? controller.signal : undefined,
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error((data && data.description) || 'Cart update failed');
        return data;
      });
    }).then(function (data) {
      window.__paransCartMetrics.push({ kind: kind, status: 'ok', duration: Math.round(performance.now() - startedAt), at: Date.now() });
      return data;
    }).catch(function (error) {
      window.__paransCartMetrics.push({ kind: kind, status: error && error.name === 'AbortError' ? 'timeout' : 'error', duration: Math.round(performance.now() - startedAt), at: Date.now() });
      throw error;
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  function postChange(body) {
    return requestCart('/cart/change.js', body, 'quantity');
  }

  function postUpdate(body, kind) {
    return requestCart('/cart/update.js', body, kind || 'update');
  }

  function enqueueMutation(task) {
    activeMutations += 1;
    setCartBusy(true);
    var run = mutationQueue.then(task, task);
    mutationQueue = run.catch(function () {});
    return run.finally(function () {
      activeMutations -= 1;
      if (activeMutations === 0 && !changeTimer && !pendingChange) setCartBusy(false);
    });
  }

  function swapSection(sectionId, html) {
    var wrap = document.getElementById('shopify-section-' + sectionId);
    if (!wrap || html == null) {
      showCartError('The cart updated, but the page could not refresh. Please reload once.');
      return false;
    }

    wrap.innerHTML = html;
    bindAll();
    return true;
  }

  function flushLineChange() {
    window.clearTimeout(changeTimer);
    changeTimer = 0;
    if (!pendingChange) {
      if (activeMutations === 0) setCartBusy(false);
      return;
    }

    var change = pendingChange;
    pendingChange = null;
    var form = getForm();
    var sectionId = form && form.getAttribute('data-section-id');
    var body = { quantity: change.quantity };
    if (change.id) body.id = change.id;
    else body.line = change.line;

    if (sectionId) body.sections = sectionId;
    body.sections_url = window.location.pathname;

    clearCartError();
    enqueueMutation(function () { return postChange(body); })
      .then(function (data) {
        if (sectionId && data.sections && data.sections[sectionId] != null) {
          swapSection(sectionId, data.sections[sectionId]);
        } else {
          showCartError('The cart updated, but the totals could not refresh. Please reload once.');
        }
        syncYmqCartState(data);
      })
      .catch(function (error) {
        showCartError(error && error.name === 'AbortError'
          ? 'The update took too long. Please try again.'
          : 'The cart could not be updated. Please try again.');
      })
      .finally(function () {
        if (pendingChange && !changeTimer) {
          changeTimer = window.setTimeout(flushLineChange, 80);
        }
      });
  }

  function changeLine(identifier, qty) {
    pendingChange = typeof identifier === 'string'
      ? { id: identifier, quantity: qty }
      : { line: identifier, quantity: qty };
    window.clearTimeout(changeTimer);
    changeTimer = window.setTimeout(flushLineChange, 220);
  }

  function getSelectedCountryOption(country) {
    return country.options[country.selectedIndex] || null;
  }

  function readProvinces(option) {
    if (!option || !option.dataset.provinces) return [];

    try {
      var provinces = JSON.parse(option.dataset.provinces);
      return Array.isArray(provinces) ? provinces : [];
    } catch (error) {
      return [];
    }
  }

  function dedupeCountryOptions(country) {
    var seen = Object.create(null);

    Array.prototype.slice.call(country.options).forEach(function (option) {
      var value = (option.value || '').trim();
      var label = (option.textContent || '').trim();
      var key = (value || label).toLowerCase();

      if (!key || key === '---') return;

      if (seen[key]) {
        option.remove();
        return;
      }

      seen[key] = true;
    });
  }

  function chooseDefaultCountry(country) {
    if (country.value) return;

    var options = Array.prototype.slice.call(country.options);
    var unitedStates = options.find(function (option) {
      return option.value === 'United States' || option.textContent.trim() === 'United States';
    });

    if (unitedStates) country.value = unitedStates.value;
  }

  function renderProvinceOptions(country, province, provinceField) {
    var provinces = readProvinces(getSelectedCountryOption(country));
    var previous = province.value;
    province.innerHTML = '';

    if (!provinces.length) {
      province.disabled = true;
      if (provinceField) provinceField.style.display = 'none';
      return;
    }

    province.disabled = false;
    if (provinceField) provinceField.style.display = '';

    provinces.forEach(function (provinceData) {
      var value = provinceData[0] || '';
      var label = provinceData[1] || value;
      province.options.add(new Option(label, value));
    });

    var previousStillExists = Array.prototype.slice.call(province.options).some(function (option) {
      return option.value === previous;
    });

    province.value = previous && previousStillExists ? previous : province.options[0].value;
  }

  function initShippingEstimateFields() {
    var country = document.getElementById('ParansEstCountry');
    var province = document.getElementById('ParansEstProvince');
    var postal = document.getElementById('ParansEstPostal');

    if (!country || !province || country.dataset.paransProvinceReady === 'true') return;

    dedupeCountryOptions(country);
    country.dataset.paransProvinceReady = 'true';
    country.setAttribute('name', 'address[country]');
    province.setAttribute('name', 'address[province]');
    if (postal) postal.setAttribute('name', 'address[zip]');

    var provinceField = province.closest('.parans-cart__field') || province.parentElement;

    chooseDefaultCountry(country);
    renderProvinceOptions(country, province, provinceField);
    country.addEventListener('change', function () {
      renderProvinceOptions(country, province, provinceField);
    });
  }

  function cartRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path.replace(/^\//, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function shippingAddressParams(country, province, postal) {
    var params = new URLSearchParams();
    params.set('shipping_address[zip]', postal ? postal.value.trim() : '');
    params.set('shipping_address[country]', country.value);
    if (province && !province.disabled && province.value) {
      params.set('shipping_address[province]', province.value);
    }
    return params;
  }

  function renderShippingMessage(result, message, type) {
    result.hidden = false;
    result.innerHTML = '<div class="parans-cart__shipping-message parans-cart__shipping-message--' + type + '">' + escapeHtml(message) + '</div>';
  }

  function findShippingSummaryValue() {
    var stableValue = document.querySelector('.parans-cart__shipping-summary-value');
    if (stableValue) return stableValue;

    var rows = document.querySelectorAll('.parans-cart__total-row');

    for (var i = 0; i < rows.length; i += 1) {
      var label = rows[i].querySelector('span:first-child');

      if (label && label.textContent.trim().toLowerCase() === 'shipping') {
        var value = rows[i].querySelector('span:last-child');

        if (value) {
          rows[i].classList.add('parans-cart__total-row--shipping');
          value.classList.add('parans-cart__shipping-summary-value');
          return value;
        }
      }
    }

    return null;
  }

  function setShippingSummary(value, type) {
    var summary = findShippingSummaryValue();

    if (!summary) return;

    summary.textContent = value;
    summary.classList.toggle('notranslate', type === 'rate');
    summary.classList.toggle('parans-cart__shipping-summary-value--note', type === 'note');
    summary.classList.toggle('parans-cart__shipping-summary-value--rate', type === 'rate');
  }

  function resetShippingSummary() {
    setShippingSummary(SHIPPING_SUMMARY_DEFAULT, 'note');
  }

  function prependYmqSelector(property, selector) {
    var ymq = window.ymqOption;
    if (!ymq || !Array.isArray(ymq[property]) || ymq[property].indexOf(selector) !== -1) return;
    ymq[property].unshift(selector);
  }

  function configureYmqCartSelectors(attempt) {
    var ymq = window.ymqOption;
    if (!ymq) {
      if ((attempt || 0) < 40) window.setTimeout(function () { configureYmqCartSelectors((attempt || 0) + 1); }, 250);
      return;
    }

    prependYmqSelector('cart_wrapper_page', '#ParansCartForm');
    prependYmqSelector('item_wrapper', '.parans-cart__row');
    prependYmqSelector('cart_info', '.parans-cart__info');
    prependYmqSelector('cart_properties', '.parans-cart__meta');
    prependYmqSelector('cart_quantity_input', '.parans-cart__qty-input');
    prependYmqSelector('cart_remove_button', '.parans-cart__remove');
    prependYmqSelector('original_price', '.parans-cart__cell--price .parans-cart__price-was');
    prependYmqSelector('final_price', '.parans-cart__cell--price .parans-cart__price-now');
    prependYmqSelector('original_line_price', '.parans-cart__cell--subtotal .parans-cart__price-was');
    prependYmqSelector('final_line_price', '.parans-cart__cell--subtotal .parans-cart__price-now');
    prependYmqSelector('cart_subtotal', '.parans-cart__total-row--subtotal > span:last-child');

    if (!ymq.__paransCartConfigured) {
      ymq.__paransCartConfigured = true;
      fetch(cartRoute('cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) { if (cart) syncYmqCartState(cart); })
        .catch(function () {});
    } else if (typeof ymq.doUpdateCartElement === 'function') {
      window.setTimeout(function () { ymq.doUpdateCartElement(); }, 0);
    }
  }

  function syncYmqCartState(cart) {
    var ymq = window.ymqOption;
    if (!ymq || !cart) return;
    if (typeof ymq.cartUpdate === 'function') {
      Promise.resolve(ymq.cartUpdate(cart, true))
        .then(scheduleCombinedGrandTotal)
        .catch(function () {});
    } else if (typeof ymq.doUpdateCartElement === 'function') {
      ymq.doUpdateCartElement();
      window.setTimeout(scheduleCombinedGrandTotal, 0);
    }
  }

  var grandTotalFrame = 0;

  function readYmqAmount(element) {
    if (!element) return NaN;
    var value = element.getAttribute('ymq-b2b-money') || element.getAttribute('data-ymq-money');
    return parseFloat(value);
  }

  function formatCartAmount(amount, reference) {
    if (window.ParansMoney && typeof window.ParansMoney.formatUsdAmount === 'function') {
      return window.ParansMoney.formatUsdAmount(amount);
    }

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var locale = document.documentElement.lang || 'en';

    if (currency && typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
      } catch (error) {}
    }

    var text = reference ? reference.textContent.trim() : '';
    var number = text.match(/[\d.,]+/);
    return number ? text.replace(number[0], amount.toFixed(2)) : amount.toFixed(2);
  }

  function writeCartAmount(element, amount) {
    if (!element) return;
    if (window.ParansMoney && typeof window.ParansMoney.applyUsdAmount === 'function') {
      window.ParansMoney.applyUsdAmount(element, amount);
      return;
    }

    var formatted = formatCartAmount(amount, element);
    if (element.textContent !== formatted) element.textContent = formatted;
  }

  function syncRoundedLineTotals() {
    var subtotal = 0;
    var hasRoundedLine = false;

    document.querySelectorAll('.parans-cart__row').forEach(function (row) {
      var unitMoney = row.querySelector('.parans-cart__cell--price .ymq-b2b-cart-qb-price [ymq-b2b-money]');
      var lineMoney = row.querySelector('.parans-cart__cell--subtotal .ymq-b2b-cart-qb-price [ymq-b2b-money]');
      var quantityInput = row.querySelector('.parans-cart__qty-input');
      var unit = readYmqAmount(unitMoney);
      var quantity = parseInt(quantityInput && quantityInput.value, 10);

      if (!lineMoney || !isFinite(unit) || isNaN(quantity)) return;

      var roundedUnit = Math.round((unit + Number.EPSILON) * 100) / 100;
      var roundedLine = Math.round(roundedUnit * quantity * 100) / 100;
      hasRoundedLine = true;
      subtotal += roundedLine;
      writeCartAmount(lineMoney, roundedLine);
      var roundedLineValue = roundedLine.toFixed(2);
      if (row.getAttribute('data-parans-rounded-line-amount') !== roundedLineValue) {
        row.setAttribute('data-parans-rounded-line-amount', roundedLineValue);
      }
    });

    if (!hasRoundedLine) return NaN;

    subtotal = Math.round(subtotal * 100) / 100;
    var subtotalMoney = document.querySelector(
      '.parans-cart__total-row--subtotal [ymq-b2b-cart-total-price] [ymq-b2b-money]'
    );
    writeCartAmount(subtotalMoney, subtotal);

    return subtotal;
  }

  function syncCombinedGrandTotal() {
    grandTotalFrame = 0;
    var subtotalRow = document.querySelector('.parans-cart__total-row--subtotal');
    var subtotalMoney = subtotalRow && subtotalRow.querySelector('[ymq-b2b-cart-total-price] [ymq-b2b-money]');
    var grandTotal = document.querySelector('[data-parans-grand-total]');
    var grandValue = grandTotal && grandTotal.querySelector('[data-parans-grand-total-value]');

    if (!subtotalMoney || !grandValue) return;

    var subtotal = syncRoundedLineTotals();
    if (!isFinite(subtotal)) subtotal = readYmqAmount(subtotalMoney);
    if (!isFinite(subtotal)) return;

    var discount = Array.prototype.slice.call(
      subtotalRow.querySelectorAll('.ymq-b2b-cart-discount-price [ymq-b2b-money]')
    ).reduce(function (total, element) {
      var amount = readYmqAmount(element);
      return total + (isFinite(amount) ? amount : 0);
    }, 0);

    var combinedTotal = Math.max(0, subtotal - discount);
    var amountValue = combinedTotal.toFixed(2);

    writeCartAmount(grandValue, combinedTotal);
    if (grandTotal.getAttribute('data-parans-grand-total-amount') !== amountValue) {
      grandTotal.setAttribute('data-parans-grand-total-amount', amountValue);
    }
  }

  function scheduleCombinedGrandTotal() {
    if (grandTotalFrame) return;
    grandTotalFrame = window.requestAnimationFrame(syncCombinedGrandTotal);
  }

  function initCombinedGrandTotal() {
    var total = document.querySelector('.parans-cart__total');
    var form = getForm();
    if (!total || !form) return;

    scheduleCombinedGrandTotal();
    if (total.dataset.paransGrandTotalReady === 'true') return;

    total.dataset.paransGrandTotalReady = 'true';
    new MutationObserver(scheduleCombinedGrandTotal).observe(form, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  function getYmqCartItems() {
    if (!window.ymqOption || !window.ymqOption.cart || !Array.isArray(window.ymqOption.cart.items)) return null;
    return window.ymqOption.cart.items;
  }

  var ymqOptionSetRequests = Object.create(null);
  var ymqOptionSetRequestQueue = Promise.resolve();

  function parseYmqOptionSets(html) {
    var sets = Object.create(null);
    var documentNode = new DOMParser().parseFromString(html, 'text/html');
    var pattern = /ymq_option\.option_sets\[`(tem[^`]+)`\]\s*=\s*(\{[^\r\n]+\});/g;

    documentNode.querySelectorAll('script').forEach(function (script) {
      var source = script.textContent || '';
      var match;

      while ((match = pattern.exec(source))) {
        try {
          sets[match[1]] = JSON.parse(match[2]);
        } catch (error) {}
      }

      pattern.lastIndex = 0;
    });

    return sets;
  }

  function getCartProductUrl(row, product) {
    if (product && product.handle) return cartRoute('products/' + encodeURIComponent(product.handle));
    var productLink = row && row.querySelector('a[href*="/products/"]');
    return productLink ? productLink.href : '';
  }

  function waitForYmqRetry(delay) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, delay);
    });
  }

  function fetchYmqOptionSets(productUrl, attempt) {
    return fetch(productUrl, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) {
          var error = new Error('YMQ product options could not be loaded');
          error.status = response.status;
          throw error;
        }
        return response.text();
      })
      .then(function (html) {
        var sets = parseYmqOptionSets(html);
        if (Object.keys(sets).length || attempt >= 2) return sets;
        return waitForYmqRetry(400 * Math.pow(2, attempt)).then(function () {
          return fetchYmqOptionSets(productUrl, attempt + 1);
        });
      })
      .catch(function (error) {
        var status = parseInt(error && error.status, 10) || 0;
        var canRetry = !status || status === 408 || status === 425 || status === 429 || status === 430 || status >= 500;
        if (!canRetry || attempt >= 2) throw error;
        return waitForYmqRetry(400 * Math.pow(2, attempt)).then(function () {
          return fetchYmqOptionSets(productUrl, attempt + 1);
        });
      });
  }

  function enqueueYmqOptionSetRequest(task) {
    var request = ymqOptionSetRequestQueue.then(task, task);
    ymqOptionSetRequestQueue = request.catch(function () {});
    return request;
  }

  function hydrateYmqCartProduct(item, row) {
    var ymq = window.ymqOption;
    var boot = window.ymq_option;
    var productId = item && item.product_id;

    if (!ymq || !boot || !productId) return Promise.resolve(false);
    if (ymqOptionSetRequests[productId]) return ymqOptionSetRequests[productId];

    var product = ymq.products && (ymq.products[productId] || ymq.products[String(productId)]);
    var productUrl = getCartProductUrl(row, product);
    if (!product || !productUrl) return Promise.resolve(false);

    ymqOptionSetRequests[productId] = enqueueYmqOptionSetRequest(function () {
      return fetchYmqOptionSets(productUrl, 0);
    })
      .then(function (sets) {
        boot.option_sets = boot.option_sets || {};
        Object.keys(sets).forEach(function (key) { boot.option_sets[key] = sets[key]; });
        if (!Object.keys(sets).length) {
          delete ymqOptionSetRequests[productId];
          return false;
        }

        product.option_init = false;
        ymq.initProductOptionData(product);
        var ready = product.ymq_status === true && Object.keys(product.ymq_option_data || {}).length > 0;
        if (!ready) delete ymqOptionSetRequests[productId];
        return ready;
      })
      .catch(function (error) {
        delete ymqOptionSetRequests[productId];
        console.error('Parans YMQ cart editor setup failed', error);
        return false;
      });

    return ymqOptionSetRequests[productId];
  }

  function ensureYmqCartEditWrapper(link, item, itemIndex) {
    if (!link || !item || !item.product_id || !(item.variant_id || item.id)) return;

    var wrapper = link.closest('.ymq-option-cart-edit-wrapper');

    if (!wrapper) {
      wrapper = document.createElement('span');
      wrapper.className = 'ymq-option-cart-edit-wrapper parans-cart__edit-wrapper';
      link.parentNode.insertBefore(wrapper, link);
      wrapper.appendChild(link);
    }

    wrapper.setAttribute(
      'ymq-option-cart-info',
      JSON.stringify({
        product_id: item.product_id,
        variant_id: item.variant_id || item.id,
        index: itemIndex,
        quantity: item.quantity || 1,
      })
    );

    link.setAttribute('href', '#');
    link.setAttribute('ymq-option-action', 'cart-edit');
    link.classList.add('ymq-option-cart-edit', 'ymq-option-edit-option');

    hydrateYmqCartProduct(item, link.closest('.parans-cart__row')).then(function (ready) {
      link.dataset.paransYmqOptionsReady = ready ? 'true' : 'false';
    });

    if (link.dataset.paransYmqEditReady !== 'true') {
      link.dataset.paransYmqEditReady = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (link.dataset.paransYmqOptionsReady === 'true') return;
        event.stopImmediatePropagation();
        hydrateYmqCartProduct(item, link.closest('.parans-cart__row')).then(function (ready) {
          if (!ready) return;
          link.dataset.paransYmqOptionsReady = 'true';
          link.click();
        });
      });
    }
  }

  function initYmqCartEditButtons(attempt) {
    var form = getForm();
    var links = form ? form.querySelectorAll('.parans-cart__edit, .ymq-option-cart-edit') : [];

    if (!links.length) {
      if ((attempt || 0) < 40) {
        window.setTimeout(function () { initYmqCartEditButtons((attempt || 0) + 1); }, 250);
      }
      return;
    }

    var items = getYmqCartItems();

    if (!items) {
      if ((attempt || 0) < 20) {
        window.setTimeout(function () {
          initYmqCartEditButtons((attempt || 0) + 1);
        }, 250);
      }

      return;
    }

    links.forEach(function (link, fallbackIndex) {
      var row = link.closest('.parans-cart__row');
      var line = row ? parseInt(row.getAttribute('data-line'), 10) : fallbackIndex + 1;
      var itemIndex = line && !isNaN(line) ? line - 1 : fallbackIndex;
      ensureYmqCartEditWrapper(link, items[itemIndex], itemIndex);
    });
  }

  function openRequestedYmqEditor(attempt) {
    var params = new URLSearchParams(window.location.search);
    var line = parseInt(params.get('parans_ymq_edit'), 10);
    if (!line || isNaN(line)) return;

    var form = getForm();
    var link = form && form.querySelector(
      '.parans-cart__row[data-line="' + line + '"] .ymq-option-cart-edit'
    );

    if (!link) {
      if ((attempt || 0) < 40) {
        window.setTimeout(function () { openRequestedYmqEditor((attempt || 0) + 1); }, 250);
      }
      return;
    }

    var cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('parans_ymq_edit');
    window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    link.click();
  }

  function readYmqPercentageTiers(productId) {
    var product = window.ymqB2b && window.ymqB2b.products && window.ymqB2b.products[productId];
    var ruleData = product && product.qb && product.qb.quantity_break_rule_data;

    if (!ruleData) return [];

    return Object.keys(ruleData)
      .map(function (key) {
        var rule = ruleData[key];
        var quantity = parseInt(rule && rule.from_value, 10);
        var discount = parseFloat(rule && rule.discount_value);
        if (!rule || String(rule.discount_type) !== '3' || isNaN(quantity) || isNaN(discount)) return null;
        return { quantity: quantity, discount: discount };
      })
      .filter(Boolean)
      .sort(function (a, b) { return a.quantity - b.quantity; });
  }

  function syncDiscountTierNotes(attempt) {
    var rows = Array.prototype.slice.call(document.querySelectorAll('.parans-cart__row[data-product-id]'));
    var quantities = Object.create(null);
    var unresolved = false;

    rows.forEach(function (row) {
      var productId = row.getAttribute('data-product-id');
      var input = row.querySelector('.parans-cart__qty-input');
      var quantity = parseInt(input && input.value, 10);
      if (!productId) return;
      quantities[productId] = (quantities[productId] || 0) + (isNaN(quantity) ? 0 : quantity);
    });

    rows.forEach(function (row) {
      var productId = row.getAttribute('data-product-id');
      var note = row.querySelector('[data-parans-discount-note]');
      var tiers = readYmqPercentageTiers(productId);

      if (!note || !productId) return;
      if (!tiers.length) {
        unresolved = true;
        return;
      }

      var totalQuantity = quantities[productId] || 0;
      var nextTier = tiers.find(function (tier) { return tier.quantity > totalQuantity; });
      var maximumTier = tiers[tiers.length - 1];

      note.textContent = nextTier
        ? 'Buy ' + nextTier.quantity + ', Get ' + nextTier.discount + '% Off Each'
        : 'Maximum Discount: ' + maximumTier.discount + '% Off Each';
    });

    if (unresolved && (attempt || 0) < 40) {
      window.setTimeout(function () { syncDiscountTierNotes((attempt || 0) + 1); }, 250);
    }
  }

  function formatShippingPrice(rate) {
    if (rate.price === '0.00' || rate.price === 0) return 'Free';
    if (window.ParansMoney && typeof window.ParansMoney.formatUsdAmount === 'function') {
      return window.ParansMoney.formatUsdAmount(parseFloat(rate.price));
    }
    var currency = rate.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return (currency ? currency + ' ' : '') + rate.price;
  }

  function renderShippingRates(result, rates) {
    if (!rates.length) {
      resetShippingSummary();
      renderShippingMessage(result, 'No shipping rates were found for this address.', 'empty');
      return;
    }

    setShippingSummary(formatShippingPrice(rates[0]), 'rate');

    result.hidden = false;
    result.innerHTML =
      '<div class="parans-cart__shipping-message parans-cart__shipping-message--success">Available shipping rates:</div>' +
      '<ul class="parans-cart__shipping-rates">' +
      rates
        .map(function (rate) {
          var name = rate.presentment_name || rate.name || 'Shipping';
          return '<li><span>' + escapeHtml(name) + '</span><strong class="notranslate">' + escapeHtml(formatShippingPrice(rate)) + '</strong></li>';
        })
        .join('') +
      '</ul>';
  }

  function fetchShippingRates(params, attempt) {
    return fetch(cartRoute('cart/async_shipping_rates.json') + '?' + params.toString(), {
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok && response.status !== 202) throw new Error('shipping rates failed');
        return response.json().catch(function () {
          return null;
        });
      })
      .then(function (data) {
        if (data && Array.isArray(data.shipping_rates)) return data.shipping_rates;
        if (attempt >= 8) throw new Error('shipping rates timed out');
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 800);
        }).then(function () {
          return fetchShippingRates(params, attempt + 1);
        });
      });
  }

  function submitShippingEstimate(calcButton, result) {
    var country = document.getElementById('ParansEstCountry');
    var province = document.getElementById('ParansEstProvince');
    var postal = document.getElementById('ParansEstPostal');

    initShippingEstimateFields();

    if (!country || !country.value) {
      renderShippingMessage(result, 'Please select a country before calculating shipping.', 'error');
      return;
    }

    var params = shippingAddressParams(country, province, postal);
    calcButton.setAttribute('aria-busy', 'true');
    calcButton.disabled = true;
    setShippingSummary('Calculating shipping rates...', 'note');
    renderShippingMessage(result, 'Calculating shipping rates...', 'loading');

    fetch(cartRoute('cart/prepare_shipping_rates.json') + '?' + params.toString(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok && response.status !== 202) throw new Error('shipping rates failed');
        return fetchShippingRates(params, 0);
      })
      .then(function (rates) {
        renderShippingRates(result, rates);
      })
      .catch(function () {
        resetShippingSummary();
        renderShippingMessage(result, 'Shipping rates could not be calculated for this address.', 'error');
      })
      .finally(function () {
        calcButton.removeAttribute('aria-busy');
        calcButton.disabled = false;
      });
  }

  function currentDiscountCodes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-parans-discount-code]'))
      .map(function (pill) { return (pill.getAttribute('data-parans-discount-code') || '').trim(); })
      .filter(Boolean);
  }

  function renderCouponResult(message, type, code) {
    var result = document.getElementById('ParansCouponResult');
    if (!result) return;
    result.className = 'parans-cart__coupon-result parans-cart__coupon-result--' + type;
    result.innerHTML = (code ? '<span class="parans-cart__coupon-code">' + escapeHtml(code) + '</span> ' : '') + escapeHtml(message);
  }

  function applyDiscountCode(input, button) {
    var code = (input.value || '').trim();
    if (!code) {
      renderCouponResult('Enter a discount code first.', 'error');
      input.focus();
      return;
    }

    var form = getForm();
    var sectionId = form && form.getAttribute('data-section-id');
    var body = {
      discount: code,
      sections_url: window.location.pathname,
    };
    if (sectionId) body.sections = sectionId;

    clearCartError();
    button.setAttribute('aria-busy', 'true');
    enqueueMutation(function () { return postUpdate(body, 'discount'); })
      .then(function (data) {
        var submitted = Array.isArray(data.discount_codes)
          ? data.discount_codes.find(function (discount) { return String(discount.code || '').toLowerCase() === code.toLowerCase(); })
          : null;

        if (!submitted || submitted.applicable === false) {
          renderCouponResult('This code is invalid or not eligible for the current cart.', 'error');
          return;
        }

        if (sectionId && data.sections && data.sections[sectionId] != null) {
          swapSection(sectionId, data.sections[sectionId]);
        }
        renderCouponResult('Discount applied. Cart totals and checkout are now linked to this code.', 'success', submitted.code || code);
        syncYmqCartState(data);
      })
      .catch(function (error) {
        renderCouponResult(error && error.name === 'AbortError'
          ? 'Applying the code took too long. Please try again.'
          : 'The discount code could not be applied. Please try again.', 'error');
      })
      .finally(function () {
        var currentButton = document.getElementById('ParansApplyCoupon');
        if (currentButton) currentButton.removeAttribute('aria-busy');
      });
  }

  function removeDiscountCode(button) {
    var code = (button.getAttribute('data-discount-code') || '').trim();
    if (!code) return;

    var form = getForm();
    var sectionId = form && form.getAttribute('data-section-id');
    var remainingCodes = currentDiscountCodes().filter(function (item) {
      return item.toLowerCase() !== code.toLowerCase();
    });
    var body = {
      discount: remainingCodes.join(','),
      sections_url: window.location.pathname,
    };
    if (sectionId) body.sections = sectionId;

    clearCartError();
    button.setAttribute('aria-busy', 'true');
    enqueueMutation(function () { return postUpdate(body, 'discount-remove'); })
      .then(function (data) {
        if (sectionId && data.sections && data.sections[sectionId] != null) {
          swapSection(sectionId, data.sections[sectionId]);
        }
        renderCouponResult('Discount removed. Product and quantity discounts remain applied.', 'success');
        syncYmqCartState(data);
      })
      .catch(function (error) {
        renderCouponResult(error && error.name === 'AbortError'
          ? 'Removing the code took too long. Please try again.'
          : 'The discount code could not be removed. Please try again.', 'error');
      });
  }

  function bindAll() {
    var form = getForm();

    if (form) {
      form.querySelectorAll('.parans-cart__remove').forEach(function (link) {
        if (link.dataset.paransCartReady === 'true') return;
        link.dataset.paransCartReady = 'true';
        link.addEventListener('click', function (event) {
          event.preventDefault();
          if (link.getAttribute('aria-disabled') === 'true') return;
          var itemKey = link.getAttribute('data-item-key');
          var line = parseInt(link.getAttribute('data-line'), 10);
          if (itemKey || line) {
            setCartBusy(true);
            changeLine(itemKey || line, 0);
          }
        });
      });

      form.querySelectorAll('.parans-cart__stepper').forEach(function (stepper) {
        if (stepper.dataset.paransCartReady === 'true') return;
        stepper.dataset.paransCartReady = 'true';
        var input = stepper.querySelector('.parans-cart__qty-input');
        if (!input) return;

        var itemKey = stepper.getAttribute('data-item-key');
        var line = parseInt(stepper.getAttribute('data-line'), 10);
        var identifier = itemKey || line;

        stepper.querySelectorAll('.parans-cart__step').forEach(function (button) {
          button.addEventListener('click', function () {
            var current = parseInt(input.value, 10);
            if (isNaN(current)) current = 0;
            current = button.getAttribute('data-step') === 'up' ? current + 1 : Math.max(0, current - 1);
            input.value = current;
            if (identifier) changeLine(identifier, current);
          });
        });

        input.addEventListener('change', function () {
          var value = parseInt(input.value, 10);
          if (isNaN(value) || value < 0) value = 0;
          input.value = value;
          if (identifier) changeLine(identifier, value);
        });

        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            input.blur();
          }
        });
      });

      var calcButton = document.getElementById('ParansCalcShipping');
      var result = document.getElementById('ParansEstResult');

      if (calcButton && result && calcButton.dataset.paransShippingReady !== 'true') {
        calcButton.dataset.paransShippingReady = 'true';
        calcButton.addEventListener('click', function () {
          submitShippingEstimate(calcButton, result);
        });
      }

      var couponInput = document.getElementById('ParansCouponCode');
      var couponButton = document.getElementById('ParansApplyCoupon');
      if (couponInput && couponButton && couponButton.dataset.paransCouponReady !== 'true') {
        couponButton.dataset.paransCouponReady = 'true';
        couponButton.addEventListener('click', function () { applyDiscountCode(couponInput, couponButton); });
        couponInput.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          applyDiscountCode(couponInput, couponButton);
        });
      }

      form.querySelectorAll('[data-parans-remove-coupon]').forEach(function (button) {
        if (button.dataset.paransCouponRemoveReady === 'true') return;
        button.dataset.paransCouponRemoveReady = 'true';
        button.addEventListener('click', function () { removeDiscountCode(button); });
      });
    }

    initShippingEstimateFields();
    resetShippingSummary();
    configureYmqCartSelectors();
    initCombinedGrandTotal();
    initYmqCartEditButtons();
    openRequestedYmqEditor();
    syncDiscountTierNotes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('cart:updated', bindAll);
})();
